import Vue from 'vue'
import Vuex from 'vuex'
import counter from './counter.js'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'


//moduels
import degreeModule from './modules/degrees/module'
import newseventsModule from './modules/newsevents/module'
import staffModule from './modules/staff/module'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  modules: {
    counter,
    degree: degreeModule,
    newsevents: newseventsModule,
    staff: staffModule
  }
})
